<template>
  <v-container
    class="align-stretch layout-container"
    style="height: calc(100% - 150px)"
  >
    <BaseHeader
      :title="$t('statistics.view.title')"
      :style-variant="11"
    >
      <template
        v-if="!isPlatformBottimmo"
        v-slot:design
      >
        <HeaderDesign />
      </template>

      <template v-slot:desc>
        <p>{{ $t('statistics.view.description') }}</p>
      </template>
    </BaseHeader>

    <v-card
      v-if="url"
      border
      class="mt-2 h-full"
    >
      <iframe
        class="h-full w-full"
        :src="url"
        frameborder="0"
        allowfullscreen
      />
    </v-card>
    <v-card
      v-else
      border
      class="mt-2"
    >
      <NoContentScreen :title="$t('statistics.view.no-content-title')" />
    </v-card>
  </v-container>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue'
import NoContentScreen from '@/components/NoContentScreen.vue'
import brandingMixin from '@/mixins/branding.js'
import HeaderDesign from '@/modules/performanceReport/HeaderDesign.vue'
import STATISTIC_DASHBOARD from '@/queries/StatisticDashboard.gql'

export default {
  components: {
    BaseHeader,
    HeaderDesign,
    NoContentScreen,
  },
  mixins: [brandingMixin],
  apollo: {
    url: {
      query: STATISTIC_DASHBOARD,
      variables() {
        return {
          companyId: this.$auth.user.companyId,
        }
      },
    },
  },
}
</script>
